const isTelURL = (url: string = '') => /^tel:/.test(url)

export default isTelURL
